import invert from "lodash/invert";

const ARABIC_DECIMAL = "۔";
const arabicNumerals: Record<number, string> = {
    0: "۰",
    1: "۱",
    2: "۲",
    3: "۳",
    4: "۴",
    5: "۵",
    6: "۶",
    7: "۷",
    8: "۸",
    9: "۹",
};
const romanNumerals = invert(arabicNumerals);

function toArabicInteger(num: string) {
    return num
        .split("")
        .map((digit) => {
            const d = parseInt(digit);
            return arabicNumerals[d] ? arabicNumerals[d] : digit;
        })
        .join("");
}

export function toArabicNumerals(num: string) {
    if (typeof num === "undefined" || num === null) {
        return "";
    }

    if (num.includes(".")) {
        const arr: string[] = num.split(".");
        const a = toArabicInteger(arr[0]);
        const b = toArabicInteger(arr[1]);
        return `${a}${ARABIC_DECIMAL}${b}`;
    }

    return toArabicInteger(num);
}

function toRomanInteger(num: string) {
    return num
        .split("")
        .map((n) => (romanNumerals[n] ? romanNumerals[n] : n))
        .join("");
}

export const toRomanNumerals = (num: string) => {
    if (!num) {
        return "";
    }

    if (num.includes(ARABIC_DECIMAL)) {
        const arr = num.split(ARABIC_DECIMAL);
        return `${toRomanInteger(arr[0])}.${toRomanInteger(arr[1])}`;
    }

    return toRomanInteger(num);
};
